import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/carlito/400.css';
import '@fontsource/carlito/700.css';
import './akku24.css';
import App from './App';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
